import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "obsidian_admin_token";

let memoryToken = null;
try {
  memoryToken = localStorage.getItem(TOKEN_KEY);
} catch {
  // storage unavailable - cookie auth still works
}

export const adminApi = axios.create({
  baseURL: API,
  // Cookies are intentionally NOT sent cross-origin: the Emergent ingress
  // returns `Access-Control-Allow-Origin: *` for OPTIONS preflights, which
  // browsers refuse to combine with credentialed requests. We rely on the
  // Bearer token in localStorage instead — works in every browser, every
  // domain, no CORS edge cases.
  withCredentials: false,
});

adminApi.interceptors.request.use((config) => {
  if (memoryToken) {
    config.headers.Authorization = `Bearer ${memoryToken}`;
  }
  return config;
});

export function setToken(token) {
  memoryToken = token;
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // storage unavailable - cookie auth still works
  }
}

export function clearToken() {
  memoryToken = null;
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}
